import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=095c22c4&scoped=true&"
import script from "./Server.vue?vue&type=script&lang=js&"
export * from "./Server.vue?vue&type=script&lang=js&"
import style0 from "./Server.vue?vue&type=style&index=0&id=095c22c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c22c4",
  null
  
)

component.options.__file = "Server.vue"
export default component.exports